import React, { FC, useEffect } from "react";

interface IProps {
    isXs: boolean
}

const SubscriptionForm: FC<IProps> = ({ isXs }) => {

    useEffect(() => {
        import("./displayblock.css");

        const formCheckInterval = setInterval(() => {
            const forms = document.querySelectorAll(".sp-form-outer");
            const container = document.getElementById("sendpulse-form-container");

            if (forms.length > 0 && container) {
                //console.log("Форма знайдена, додаємо в контейнер");

                // Видаляти перший чи останній елемент
                if (isXs) {
                    forms[0].remove(); // Видаляти перший елемент
                } else {
                    forms[forms.length - 1].remove(); // Видаляти останній елемент
                }

                // Оновлюємо список форм після видалення
                const updatedForms = Array.from(document.querySelectorAll(".sp-form-outer"));
                //console.log(updatedForms); // Виводимо оновлений список форм

                // Додаємо залишкові форми в контейнер
                updatedForms.forEach(form => {
                    container.appendChild(form);
                });

                clearInterval(formCheckInterval); // Зупиняємо перевірку
            } else {
                //console.log("Форма ще не знайдена, повторюємо пошук...");
            }
        }, 1000);

    }, []);

    return (
        <div id="sendpulse-form-container" />
    );
};

export default SubscriptionForm;